import { render, staticRenderFns } from "./LegalCases.vue?vue&type=template&id=3e9d2a49"
import script from "./LegalCases.vue?vue&type=script&lang=js"
export * from "./LegalCases.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports